/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccessToken } from "../../commons/types/AccessToken";
export const AccessTokenResponse = core.serialization.object({
    data: AccessToken,
});
